module.exports = __webpack_public_path__ + "img/404page.5ba807d.png";